import logo from './logo.svg';
import './App.css';
import { useState, useEffect } from "react";

function App() {
  const [data, setData] = useState({
    name: "",
    main: {temp: ""}
  });

  const makeAPICall = async () => {
    try {
      const response = await fetch('https://97398oth4c.execute-api.us-east-1.amazonaws.com/');
      const result = await response.json();
      setData(result.data);
    }
    catch(e) {
      console.log(e)
    }
  }
  useEffect(() => {
    makeAPICall();
  }, []);
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Température à : {data.name}</p>
        <p>
          {(parseInt(data.main.temp) - 273)} °C
        </p>
      </header>
    </div>
  );
}

export default App;
